import request from '@utils/request'
import cloneDeep from 'lodash/cloneDeep'

export const state = {
  cart: [],
  totalPrice: 0,
  priceChange: [],
  couponInfo: {},
}

export const getters = {
  cartList(state) {
    const addData = state.cart.filter((item) => item.hasOwnProperty('type') && !item.hasOwnProperty('code'))
    const productsData = state.cart.filter((item) => !item.hasOwnProperty('type'))
    addData.forEach((item) => productsData.push(item))
    return productsData
  },
  goodsTotal(state) {
    const productsData = state.cart.filter((item) => !item.hasOwnProperty('type'))
    return productsData.reduce((acc, cur) => acc + cur.prices[0].price * cur.qty, 0)
  },
}

export const mutations = {
  UPDATE_CART(state, product) {
    const updateCart = (pro) => {
      const index = state.cart.findIndex((item) => item.no === pro.no)
      if (index !== -1) {
        state.cart[index].qty = pro.qty
      } else {
        state.cart.push(pro)
      }
    }
    if (Array.isArray(product)) {
      product.forEach(updateCart)
    } else if (product !== null && typeof product === 'object') {
      updateCart(product)
    }
  },
  UPDATE_PURCHASE_NUM(state, info) {
    const { type, id } = info
    const index = state.cart.findIndex((item) => item.alias === id)
    if (index !== -1) {
      state.cart[index].qty = type === 'plus' ? state.cart[index].qty + 1 : Math.max(1, state.cart[index].qty - 1)
    }
  },
  UPDATE_COUPON(state, coupon) {
    state.couponInfo = coupon
  },
  UPDATE_TOTALPRICE(state, total) {
    state.totalPrice = total
  },
  CHANGE_PRICE(state, value) {
    state.cart = state.cart.filter((item) => !item.hasOwnProperty('type'))
    state.priceChange = value
    state.priceChange.forEach((item) => state.cart.push(item))
  },
  DELETE_PRODUCT(state, index) {
    state.cart.splice(index, 1)
  },
  CLEAR_CART(state) {
    state.cart = []
    state.totalPrice = 0
    state.priceChange = []
    state.couponInfo = {}
  },
}
